import React, { useState } from 'react';
import { 
  BookOpen, 
  School,
  School2,
  GraduationCap,
  Omega,
  X,
  Mail,
  Phone,
  Handshake,
  BriefcaseBusiness
} from 'lucide-react';

import Logo from '../assets/logo.webp';

const ContactModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-8 max-w-md w-full mx-4 relative">
        <button 
          onClick={onClose}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
        >
          <X size={24} />
        </button>
        
        <h2 className="text-2xl font-bold mb-6 text-teal-600">Contact Us</h2>
        
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <Mail className="text-teal-600" size={20} />
            <div>
              <p className="text-sm text-gray-500">Email</p>
              <p className="text-lg">sudutta@gmail.com</p>
            </div>
          </div>
          
          <div className="flex items-center gap-3">
            <Phone className="text-teal-600" size={20} />
            <div>
              <p className="text-sm text-gray-500">Phone</p>
              <p className="text-lg">+91 9731166822</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ActiveClientPage = () => {

  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 font-lato">
      {/* Simple Header */}
    <header className="bg-teal-600 shadow-lg w-full">
      <div className="w-full px-4 lg:px-12">
        <div className="max-w-[1920px] mx-auto">
          <div className="flex items-center h-20 lg:h-24">
            <div className="flex-shrink-0 lg:w-[15%] pl-0 lg:pl-8">
                <img 
                  src={Logo}
                  alt="Nirvana Career Counselling - Expert Guidance in Bangalore and Jamshedpur"
                  loading="lazy" 
                  className="h-16 lg:h-20 object-contain mt-2"
                />
            </div>
            <div className="hidden lg:flex flex-grow justify-center items-center ml-16">
              <h1 className="text-white text-xl md:text-4xl font-bold font-lato text-center mx-auto">
                    Welcome to Nirvana Career Counselling
                </h1>
            </div>

            {/* Contact Info - With specific width */}
            <div className="hidden lg:flex lg:w-[22%] justify-end items-center pl-12">
              <button 
                onClick={() => setIsModalOpen(true)} 
                className="px-6 py-2 rounded-md transition-all duration-300 bg-white text-teal-700 font-bold hover:bg-yellow-500 hover:text-black"
              >
                Contact Us
              </button>
            </div>
            </div>
            </div>
        </div>
        </header>



      {/* Assessments Section */}
      <div className="py-16 bg-white font-lato">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Welcome Message */}
          <div className="bg-teal-50 border border-teal-200 rounded-lg p-4">
            <p className="text-center text-lg text-teal-800">
              Thank you for choosing Nirvana and taking your first step to success! 😄
            </p>
          </div>
          <section aria-label="Psychometric Assessments" className="py-20 bg-white font-lato">
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    {/* Section Header */}
    <div className="text-center mb-16">
      <h2 className="text-4xl font-bold text-gray-900 mb-4">Psychometric Career Assessments</h2>
      <div className="w-24 h-1 bg-teal-600 mx-auto rounded-full mb-8"></div>
      <p className="text-gray-600 max-w-3xl mx-auto px-4">
        Discover your perfect career path with our comprehensive assessment tools designed for students and professionals at every stage.
      </p>
    </div>

    {/* First Row - 4 Cards */}
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
      {/* Card 1 */}
      <div className="bg-white rounded-lg shadow-md p-6 transform transition duration-300 hover:scale-105 hover:shadow-xl flex flex-col justify-between border-2 border-teal-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
            <BookOpen className="h-8 w-8 text-teal-600" />
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-4 flex flex-col items-center">
            <span>Career Analysis</span>
            <span>Classes 2nd to 7th</span>
          </h4>
          <p className="text-gray-600 mb-4 text-center">
            Discover your child's Multiple Intelligence profile and early aptitude indicators.
          </p>
        </div>
        <a
          href="https://careertest.edumilestones.com/student-dashboard/suitability-registration/login/MTM4MA==/as11"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-yellow-300 hover:text-black transition-colors focus:outline-none focus:ring-2 focus:ring-teal-600 text-center inline-block"
        >
          Start Assessment
        </a>
      </div>

      {/* Card 2 */}
      <div className="bg-white rounded-lg shadow-md p-6 transform transition duration-300 hover:scale-105 hover:shadow-xl flex flex-col justify-between border-2 border-teal-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
            <School className="h-8 w-8 text-teal-600" />
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-4 flex flex-col items-center">
            <span>Career Analysis</span>
            <span>Classes 8th-10th</span>
          </h4>
          <p className="text-gray-600 mb-4 text-center">
            Find the most suitable career path and subject combinations for high school success.
          </p>
        </div>
        <a
          href="https://careertest.edumilestones.com/student-dashboard/suitability-registration/login/MTM4MA==/as12"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-yellow-300 hover:text-black transition-colors focus:outline-none focus:ring-2 focus:ring-teal-600 text-center inline-block"
        >
          Start Assessment
        </a>
      </div>

      {/* Card 3 */}
      <div className="bg-white rounded-lg shadow-md p-6 transform transition duration-300 hover:scale-105 hover:shadow-xl flex flex-col justify-between border-2 border-teal-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
            <School2 className="h-8 w-8 text-teal-600" />
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-4 flex flex-col items-center">
            <span>Career Analysis</span>
            <span>Classes 11th-12th</span>
          </h4>
          <p className="text-gray-600 mb-4 text-center">
            Get a detailed career roadmap with college and course recommendations.
          </p>
        </div>
        <a
          href="https://careertest.edumilestones.com/student-dashboard/suitability-registration/login/MTM4MA==/as13"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-yellow-300 hover:text-black transition-colors focus:outline-none focus:ring-2 focus:ring-teal-600 text-center inline-block"
        >
          Start Assessment
        </a>
      </div>

      {/* Card 4 */}
      <div className="bg-white rounded-lg shadow-md p-6 transform transition duration-300 hover:scale-105 hover:shadow-xl flex flex-col justify-between border-2 border-teal-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
            <Omega className="h-8 w-8 text-teal-600" />
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-4 flex flex-col items-center">
            <span>Career Analysis</span>
            <span>Graduates</span>
          </h4>
          <p className="text-gray-600 mb-4 text-center">
          Plan your post-graduation career path with detailed insights and guidance.
          </p>
        </div>
        <a
          href="https://careertest.edumilestones.com/student-dashboard/suitability-registration/login/MTM4MA==/as14"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-yellow-300 hover:text-black transition-colors focus:outline-none focus:ring-2 focus:ring-teal-600 text-center inline-block"
        >
          Start Assessment
        </a>
      </div>
    </div>

    {/* Second Row - 3 Cards (Offset) */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-8 max-w-5xl mx-auto">
      {/* Card 5 */}
      <div className="bg-white rounded-lg shadow-md p-6 transform transition duration-300 hover:scale-105 hover:shadow-xl flex flex-col justify-between border-2 border-teal-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
            <Handshake className="h-8 w-8 text-teal-600" />
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-4">
            Business Management
          </h4>
          <p className="text-gray-600 mb-4 text-center">
            Explore your potential in business and management careers.
          </p>
        </div>
        <a
          href="https://careertest.edumilestones.com/student-dashboard/suitability-registration/login/MTM4MA==/Bm144"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-yellow-300 hover:text-black transition-colors focus:outline-none focus:ring-2 focus:ring-teal-600 text-center inline-block"
        >
          Start Assessment
        </a>
      </div>

      {/* Card 6 */}
      <div className="bg-white rounded-lg shadow-md p-6 transform transition duration-300 hover:scale-105 hover:shadow-xl flex flex-col justify-between border-2 border-teal-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
            <GraduationCap className="h-8 w-8 text-teal-600" />
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-4 flex flex-col items-center">
            <span>Career Analysis</span>
            <span>Professionals</span>
          </h4>
          <p className="text-gray-600 mb-4 text-center">
            Get guidance for career transitions and professional growth opportunities.
          </p>
        </div>
        <a
          href="https://careertest.edumilestones.com/student-dashboard/suitability-registration/login/MTM4MA==/as204"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-yellow-300 hover:text-black transition-colors focus:outline-none focus:ring-2 focus:ring-teal-600 text-center inline-block"
        >
          Start Assessment
        </a>
      </div>

      {/* Card 7 */}
      <div className="bg-white rounded-lg shadow-md p-6 transform transition duration-300 hover:scale-105 hover:shadow-xl flex flex-col justify-between border-2 border-teal-300">
        <div className="flex flex-col items-center text-center">
          <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mb-6">
            <BriefcaseBusiness className="h-8 w-8 text-teal-600" />
          </div>
          <h4 className="text-xl font-semibold text-gray-800 mb-4 flex flex-col items-center">
            Engineering Assessment
          </h4>
          <p className="text-gray-600 mb-4 text-center">
          `Choose the right engineering specialization based on your aptitude and interests.
          </p>
        </div>
        <a
          href="https://careertest.edumilestones.com/student-dashboard/suitability-registration/login/MTM4MA==/as16"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-4 w-full px-6 py-2 bg-teal-600 text-white rounded-md hover:bg-yellow-300 hover:text-black transition-colors focus:outline-none focus:ring-2 focus:ring-teal-600 text-center inline-block"
        >
          Start Assessment
        </a>
      </div>
    </div>
  </div>
</section>
        </div>
      </div>
      <ContactModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default ActiveClientPage;